<h2 mat-dialog-title>Import Recipients from ENIS</h2>
<div class="enis-params-block">
  <label class="enis-params-label">Parameters</label>
  <div class="enis-params-input-row">
    <input class="enis-params-input" #input readonly (click)="selectText()" [value]="enisString" />
    <button class="enis-params-copy-btn" mat-icon-button (click)="copied()" [ngxClipboard]="input">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
  <div class="enis-params-hint mat-caption">Use these parameters for the extract</div>
</div>

<div class="postmortem-checkbox-container">
  <mat-checkbox [(ngModel)]="isPostmortemWaitlist" color="primary">
    Import as postmortem waitlist patients
  </mat-checkbox>
</div>

<mat-dialog-content>
  <mat-card class="dropzone" [class.hover]="hover$ | async" [class.compact]="compact" (dragover)="drag($event)" (dragleave)="drag($event)" (drop)="drop($event)" (click)="fileInput.click()">
    <mat-spinner *ngIf="busy$ | async" color="accent"></mat-spinner>
    <div *ngIf="!(busy$ | async)" fxLayout="column">
      <div *ngIf="!compact" class="icon">
        <mat-icon>cloud_upload</mat-icon>
      </div>
      <div>Select file to upload</div>
      <div class="mat-caption">or drag and drop CSV file</div>
    </div>
  </mat-card>
  <input #fileInput style="display: none" (change)="onFileChange($event)" accept=".xlsx, .xls, .csv" type="file" />
</mat-dialog-content>
<mat-dialog-actions fxLayout="row">
  <div fxFlex fxFlexFill></div>
  <button class="cancelbutton" mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
